import type { PlanktonProductSearchResponse } from "../plankton";

export function chunkBcPricesRequest(chunkSize: number, items: Array<BcProductPriceRequestItem>): Array<Array<BcProductPriceRequestItem>> {
  function chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];

    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }

    return result;
  }

  return chunkArray<BcProductPriceRequestItem>(items, chunkSize);
}

export function chunkProductSearchResponse(chunkSize: number, productSearch: PlanktonProductSearchResponse): Array<Array<number>> {
  const productIdList: Array<number> = Object.values(productSearch.pagedProducts)
    .flatMap((products: Array<any>) => products.map(product => product.productId));

  function chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];

    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }

    return result;
  }

  return chunkArray<number>(productIdList, chunkSize);
}

export function chunkNumbers(chunkSize: number, items: Array<number>): Array<Array<number>> {
  function chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];

    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }

    return result;
  }

  return chunkArray<number>(items, chunkSize);
}
